<template lang="pug">
#select-cultura
    el-radio-group(
        v-model='codigoCultura',
        @change='onChangeHandle',
        size='small'
    )
        el-radio-button(label='SOJA') Soja
        el-radio-button(label='MILHO') Milho
        el-radio-button(v-if='showAlgodao', label='ALGODAO') Algodão
</template>

<script>
export default {
    name: 'SelectCultura',

    data() {
        return {
            codigoCultura: 'SOJA'
        };
    },

    props: {
        showAlgodao: {
            type: Boolean,
            required: false
        }
    },

    methods: {
        onChangeHandle() {
            this.$emit('changeCultura', this.codigoCultura);
        }
    }
};
</script>

<style lang="scss" scoped>
#select-cultura {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: map-get($font-size, x-small);
}
</style>
